/* eslint-disable */
import React from 'react'
import '../../printRole.css'
import {message} from 'antd'
import http from '../Interceptor/Interseptor'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Loader from '../loaders/loader'
import jMoment from 'moment-jalaali'
var Barcode = require('react-barcode')

export default class PrintRole extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      list: []
    }
  }
  componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search)
    urlParams.delete('sortBy')
    urlParams.append('sortBy', 'driverId_Asc,invoiceNum_Asc')
    let queryString = urlParams.toString().replace('%2C', ',')
    if (this.props.location.search !== '') {
      let params = '?' + queryString + '&export=true'
      this.setState({
        loading: true
      })
      http
        .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_INDIVIDUAL}${params}`, {
          timeout: 100000
        })
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null) {
            let res = response.data.object.result
            res.forEach((item) => {
              item.invoiceNum = item.invoice.invoiceNum.toString()
            })
            this.setState({
              list: res,
              loading: false
            })
          } else {
            this.setState({
              loading: false
            })
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    } else {
      message.error('امکان ساخت گزارش بدون ارسال فیلتر وجود ندارد')
    }
  }

  exportPrint = () => {
    // var css = '@page { size:8cm 12cm portrait}',
    //     head = document.head || document.getElementsByTagName('head')[0],
    //     style = document.createElement('style');
    // style.type = 'text/css';
    // style.media = 'print';
    // if (style.styleSheet){
    //     style.styleSheet.cssText = css;
    // } else {
    //     style.appendChild(document.createTextNode(css));
    // }
    // head.appendChild(style);
    setTimeout(() => {
      window.print()
    }, 500)
  }
  sum = (item) => {
    let initialVal = 0
    let sum = item.reduce(function(acc, current) {
      return Number(acc) + Number(current.quantity)
    }, initialVal)
    if (sum !== null) {
      return parseFloat(sum.toFixed(2))
    } else {
      return ''
    }
  }
  render() {
    const options = {
      width: 2,
      height: 30,
      format: 'CODE128',
      displayValue: false,
      fontOptions: '',
      font: 'monospace',
      textAlign: 'center',
      textPosition: 'top',
      textMargin: 2,
      fontSize: 20,
      background: 'transparent',
      lineColor: '#000',
      margin: 10,
      marginTop: undefined,
      marginBottom: undefined,
      marginLeft: undefined,
      marginRight: undefined
    }
    return (
      <div className="">
        <Loader show={this.state.loading} />
        <button className="printButton mb-2" onClick={this.exportPrint}>
          چاپ
        </button>
        <div className="wrapperRoles">
          {this.state.list.map((item) => (
            <>
              <div className="roleLabel">
                <div className="text-center" style={{marginBottom: '-10px'}}>
                  <h1 className="font-weight-bold mb-0" style={{fontSize: '7em', letterSpacing: '5px', lineHeight: 1}}>
                    {item.invoiceNum.substr(2, item.invoiceNum.length)}
                  </h1>
                </div>
                {/*<div>*/}
                {/*    <Barcode value={item.invoiceNum} {...options}/>*/}
                {/*</div>*/}
                <div className="d-flex flex-row justify-content-between" style={{marginBottom: '-6px'}}>
                  <span>
                    <h2 className="font-weight-bold mb-0">
                      {item.planTimeFrom.substr(0, 2) + ' تا ' + item.planTimeTo.substr(0, 2)}
                    </h2>
                  </span>
                  <span className="font-weight-bold">
                    <h3 className="mb-0 font-weight-bold" style={{letterSpacing: '2px', marginBottom: '-6px'}}>
                      {jMoment(item.planDate).format('jYY/jM/jD')}
                    </h3>
                  </span>
                </div>
                <div className="d-flex flex-row justify-content-between row mx-0">
                  <div className="col-12 p-0">
                    <div className="w-100 p-0" style={{marginBottom: '-3px'}}>
                      <span>رساننده : </span>
                      <span>{item.driver !== null && item.driver.name}</span>
                    </div>
                    <div className="w-100 p-0 d-flex flex-row justify-content-between align-items-center align-content-center">
                      <p className="mb-0">
                        <span>تحویل گیرنده : </span>
                        <span>{item.customer.userCode + ' - '}</span>
                        {item.invoice.recipientName !== null ? (
                          <span>
                            {item.invoice !== null && item.invoice.recipientName.length > 15
                              ? item.invoice.recipientName.substr(0, 15) + '..'
                              : item.invoice.recipientName}
                          </span>
                        ) : null}
                      </p>
                      <h6 className="mb-0 font-weight-bold" style={{letterSpacing: '2px', marginBottom: '0'}}>
                        {item.invoice !== null && item.invoice.invoiceNum}
                      </h6>
                    </div>
                  </div>
                  <div className="col-12 p-0" style={{marginBottom: '0'}}>
                    <span>آدرس : </span>
                    <span style={{lineHeight: 1}}>
                      {item.invoice !== null && item.invoice.address.length > 100
                        ? item.invoice.address.substr(0, 100) + '...'
                        : item.invoice.address}
                    </span>
                  </div>
                </div>

                {item.items.filter((i) => i.stockProductId !== null).length <= 6 ? (
                  <table className="w-100 mt-2 labelItems">
                    <tr>
                      <td className="text-center">#</td>
                      {/*<td className='text-center small font-weight-bold' style={{width: '15%'}}>بارکد کالا</td>*/}
                      <td className="text-center small font-weight-bold">شرح</td>
                      <td className="text-center small font-weight-bold">تعداد</td>
                    </tr>
                    {item.items
                      .filter((i) => i.stockProductId !== null)
                      .map((ch, n) => (
                        <>
                        <tr className="">
                          <td className="small text-center">{n + 1}</td>
                          {/*<td className='small text-justify' style={{width: '15%'}}>{ch.productCode}</td>*/}
                          <td className="">
                            {ch.productName.length > 35 ? ch.productName.substr(0, 35) + '..' : ch.productName}
                          </td>
                          <td className="small text-center">{ch.quantity + ' ' + ch.productUnitTitle}</td>
                        </tr>
                        </>
                      ))}
                  </table>
                ) : (
                  <div className="d-flex flex-column justify-content-center align-items-center justify-content-around">
                    <h2 className="mt-2 font-weight-bold text-center">
                      {item.items.filter((i) => i.stockProductId !== null).length + ' ردیف کالا '}
                    </h2>
                    <h2 className="mt-2 font-weight-bold text-center">
                      تعداد : {this.sum(item.items.filter((i) => i.stockProductId !== null))}
                    </h2>
                  </div>
                )}
              </div>
              <h1 className="breakHr" />
            </>
          ))}
        </div>
      </div>
    )
  }
}
